module.exports = __webpack_public_path__ + "static/media/register-successful-herdies.37ccf4ad.svg";